import { useState, useEffect } from 'react';

interface ModuleCompletion {
  [topicId: string]: {
    [moduleIndex: number]: boolean;
  };
}

export const useModuleCompletion = () => {
  const [completedModules, setCompletedModules] = useState<ModuleCompletion>(() => {
    const stored = localStorage.getItem('moduleCompletion');
    return stored ? JSON.parse(stored) : {};
  });

  useEffect(() => {
    localStorage.setItem('moduleCompletion', JSON.stringify(completedModules));
  }, [completedModules]);

  const markModuleComplete = (topicId: string, moduleIndex: number) => {
    setCompletedModules(prev => ({
      ...prev,
      [topicId]: {
        ...(prev[topicId] || {}),
        [moduleIndex]: true
      }
    }));
  };

  const isModuleComplete = (topicId: string, moduleIndex: number): boolean => {
    return completedModules[topicId]?.[moduleIndex] || false;
  };

  const getTopicProgress = (topicId: string, totalModules: number): number => {
    if (!completedModules[topicId]) return 0;
    const completed = Object.keys(completedModules[topicId]).length;
    return Math.round((completed / totalModules) * 100);
  };

  const getCompletedCount = (topicId: string): number => {
    if (!completedModules[topicId]) return 0;
    return Object.keys(completedModules[topicId]).length;
  };

  return {
    markModuleComplete,
    isModuleComplete,
    getTopicProgress,
    getCompletedCount
  };
};

